import type { CSSProperties } from 'react'

import { Box, Stack, Alert, AlertTitle } from '@mui/material'
import { SimpleSelect } from '@workwave-tidal/core/components'

import { useCanCopyToTerritory } from '../hooks/useCanCopyToTerritory'
import { useController } from '../hooks/useController'
import { useControllerActions } from '../hooks/useControllerActions'
import { useTerritoryDropdownItems } from '../hooks/useTerritoryDropdownItems'
import { useTexts } from '../useTexts'

const layoutStyle: CSSProperties = { minHeight: 200, width: '100%' }

export function Body() {
  const texts = useTexts()
  const handlers = useControllerActions()
  const {
    invalid,
    data: { territories, id },
  } = useController()

  const canCopyToTerritory = useCanCopyToTerritory(id)

  const dropdownItems = useTerritoryDropdownItems(territories, id)

  return (
    <Stack direction="column" marginTop={4} style={layoutStyle}>
      <Box mb={4} width="100%">
        <Stack direction="row" alignItems="center">
          <Box height="auto" width="100%" flex="0 1 auto">
            <SimpleSelect
              label={texts.territoryDropdownTitle}
              options={dropdownItems}
              onChange={event => handlers.onTerritoryChange(event.target.value)}
              disabled={!dropdownItems || invalid}
              defaultValue={id}
            />
          </Box>
        </Stack>
      </Box>

      {canCopyToTerritory ? (
        <Alert severity="warning">
          <AlertTitle>{texts.replaceWarningCardTitle}</AlertTitle>
          {texts.replaceWarningCardDescription}
        </Alert>
      ) : (
        <Alert severity="warning">
          <AlertTitle>{texts.noAdvancedVoiceSupportedTitle}</AlertTitle>
          {texts.noAdvancedVoiceSupportedDescription}
        </Alert>
      )}
    </Stack>
  )
}
